<template>
  <div class="group-input">
    <h3>
      <i class="icon icon--group-big"></i>
      <span v-if="title"
          v-html="title"></span>
    </h3>

    <div class="name-input">
      <ui-input-text v-model="groupName"
                     :type="'text'"
                     :placeholder="$t('common.placeHolder.within', { count: 10 })"
                     :error="error">{{ $t('group.editMode.groupName') }}</ui-input-text>
    </div>

    <div class="buttons">
      <ui-button @click="$emit('onCancel')">
        {{ $t('common.cancel') }}
      </ui-button>
      <ui-button :primary2="true"
                 :disabled="!!error || groupName.length < 1"
                 @click="submit">
        {{ $t('common.confirm') }}
      </ui-button>
    </div>
  </div>
</template>

<script>
import UiButton from '@/components/ui/UiButton'
import UiInputText from '@/components/ui/UiInputText'

export default {
  name: 'GroupInput',
  components: {
    UiButton,
    UiInputText
  },
  props: {
    title: {
      type: String
    },
    groupItems: {}
  },
  computed: {
    sid () {
      return this.$route.query.sid
    }
  },
  watch: {
    groupName () {
      this.error = ''
    }
  },
  methods: {
    checkGroupNameDuplication (groupName) {
      const groupNames = this.groupItems.map(item => item.value.groupName).concat(['자동', 'Automatic', '自動'])
      return groupNames.includes(groupName)
    },

    submit () {
      if (this.checkGroupNameDuplication(this.groupName)) {
        this.error = this.$t('group.editMode.duplicatedGroupName').replace('<br>', '')
      } else if (this.groupName && this.groupName.length > 10) {
        this.error = this.$t('group.editMode.withinGroupName', { count: 10 }).replace('<br>', '')
      } else {
        this.$emit('onSubmit', this.groupName)
      }
    }
  },
  data () {
    return {
      error: '',
      groupName: '',
      limit: 10
    }
  }
}
</script>

<style lang="scss" scoped>
.group-input {
  position: relative;
  width: 430px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #fff;
  text-align: center;

  h3 {
    padding: 50px 30px 0 30px;
    font-size: 15px;
    font-weight: 500;
    color: #2f2f2f;
    text-align: center;

    span {
      display: block;
      margin-top: 10px;
      font-size: 20px;
      font-weight: 500;
      line-height: 1.2;
      color: #444;
    }
  }

  .name-input {
    margin: 25px 30px 30px;
    padding: 6px 40px 30px;
    border-radius: 5px;
    border: solid 1px #d7d7d7;
    background-color: #f4f4f4;

    h5 {
      text-align: center;
    }
  }

  .buttons {
    padding: 0 20px 23px;

    .ui-btn {
      min-width: 90px;
      margin: 0 2px 0 3px;
    }
  }
}
</style>
